export enum ApplicationProductSelectionMode {
    Continuous = "Continuous",
    AddOn = "AddOn"
}